export default __webpack_public_path__ + "static/media/info-icon.4298baa6.svg";